import { SvgIconComponent } from "@mui/icons-material";
import BuildIcon from "@mui/icons-material/Build";
import BuildCircleOutlinedIcon from "@mui/icons-material/BuildCircleOutlined";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import RestoreIcon from "@mui/icons-material/Restore";
import SettingsIcon from "@mui/icons-material/Settings";
import { ProjectType } from "../../../clients/graphqlTypes.js";

// Frontend-only mapping of ProjectType -> MUI SvgIcon. Exhaustive over the
// enum (Record<ProjectType, ...>), so TypeScript enforces that any new
// ProjectType added to the schema is mapped here.
export const PROJECT_TYPE_ICONS: Record<ProjectType, SvgIconComponent> = {
  NEW: FiberNewIcon,
  REPAIR: BuildCircleOutlinedIcon,
  RENOVATION: RestoreIcon,
  MAINTENANCE: SettingsIcon,
  DIY: BuildIcon,
  OTHER: MoreHorizIcon,
};
